import { ApiError } from '../api/client.js';

/**
 * Turn an unknown caught value into something safe to show a user.
 *
 * Narrows with `instanceof` rather than casting: a network failure, a bug in our
 * own code, or anything else thrown is not an ApiError, and reading `.message`
 * off it via a cast would surface an internal string — or `undefined` — to the
 * user as if it were a considered message.
 */
export function describeError(caught: unknown): string {
  if (caught instanceof ApiError) return caught.message;
  return 'Something went wrong. Please try again.';
}

export function isSessionExpired(caught: unknown): boolean {
  return caught instanceof ApiError && caught.isSessionExpired;
}

export function isVersionConflict(caught: unknown): boolean {
  return caught instanceof ApiError && caught.code === 'version_conflict';
}
